// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"410":"completeInsurance","703":"admins","781":"insurance","884":"admin","966":"login"}[chunkId] || chunkId) + "." + {"410":"01532187","556":"008c3788","703":"9ec2a483","781":"2f0cd74a","884":"e7879cc3","966":"972332ef"}[chunkId] + ".js";
};